<style>
#featureCardModal .v--modal-box.v--modal {
  min-height: 360px !important;
  min-width: 550px !important;
}
#featureCardModal :not(.v-icon) {
  font-size: 12px;
}
#featureCardModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#featureCardModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#featureCardModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#featureCardModal .btn--card {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
#featureCardModal .caption--identification {
  display: inline;
  text-align: center;
  vertical-align: super;
}
#featureCardModal .v-chip__content {
  cursor: pointer;
}
</style>

<template>
  <Modal
    modalName="featureCardModal"
    :title="cardTitle"
    @closed="closed()"
    :editing="editing"
    @editingStart="startEditing()"
    @editingSave="saveEditing()"
    @editingCancel="cancelEditing()"
    @opened="updateList(), getDicts()"
    :buttons="['']"
    :module="module"
  >
    <v-tabs
      color="#2a579a"
      dark
      centered
      grow
      active-class="tab--active"
      :hide-slider="true"
      height="35"
    >
      <v-tab v-if="attributes">ATRYBUTY OBIEKTU</v-tab>
      <v-tab-item>
        <template v-show="hasAnyData">
          <template v-if="hasDefaultData">
            <v-layout>
              <v-flex xs12>
                <v-subheader>DANE TECHNICZNE</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs5>
                <template v-for="(attribute, index, key) in attributes.default">
                  <template v-if="key < halfDefaultAttributesLength">
                    <v-text-field
                      :key="`firstLine${index}`"
                      v-if="attribute && attribute.type === 'text'"
                      :readonly="!editing"
                      v-model="attribute.value"
                      :label="attribute.display_name"
                    ></v-text-field>
                    <v-menu
                      v-else-if="attribute.type === 'date'"
                      v-model="attribute.dateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :key="`firstLine${index}`"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :readonly="!editing"
                    >
                      <template :readonly="!editing" v-slot:activator="{ on }">
                        <v-text-field
                          v-model="attribute.dateFormatted"
                          :label="attribute.display_name"
                          prepend-icon="event"
                          :readonly="!editing"
                          @input="
                            attribute.value = parseDate(attribute.dateFormatted)
                          "
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="attribute.value"
                        @input="attribute.dateMenu = false"
                        color="#2a579a"
                        no-title
                        :readonly="!editing"
                      ></v-date-picker>
                    </v-menu>
                    <v-select
                      :clearable="editing"
                      v-else
                      :items="attribute.dict.values"
                      :key="`firstLine${index}`"
                      no-data-text="Brak wartości słownikowych"
                      v-model="attribute.value"
                      :readonly="!editing"
                      :label="attribute.display_name"
                      :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                    ></v-select>
                  </template>
                </template>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <template
                  v-for="(attribute, index, keyS) in attributes.default"
                >
                  <template v-if="keyS >= halfDefaultAttributesLength">
                    <v-text-field
                      :key="`secondLine${index}`"
                      v-if="attribute && attribute.type === 'text'"
                      :readonly="!editing"
                      v-model="attribute.value"
                      :label="attribute.display_name"
                    ></v-text-field>
                    <v-menu
                      v-else-if="attribute && attribute.type === 'date'"
                      v-model="attribute.dateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :key="`secondLine${index}`"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :readonly="!editing"
                    >
                      <template :readonly="!editing" v-slot:activator="{ on }">
                        <v-text-field
                          v-model="attribute.dateFormatted"
                          :label="attribute.display_name"
                          prepend-icon="event"
                          :readonly="!editing"
                          @input="
                            attribute.value = parseDate(attribute.dateFormatted)
                          "
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="attribute.value"
                        @input="attribute.dateMenu = false"
                        color="#2a579a"
                        no-title
                        :readonly="!editing"
                      ></v-date-picker>
                    </v-menu>
                    <v-select
                      :clearable="editing"
                      v-if="attribute && attribute.type === 'select'"
                      :items="attribute.dict.values"
                      :key="`secondLine${index}`"
                      no-data-text="Brak wartości słownikowych"
                      v-model="attribute.value"
                      :readonly="!editing"
                      :label="attribute.display_name"
                      :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                    ></v-select>
                  </template>
                </template>
              </v-flex>
            </v-layout>
          </template>
          <template v-if="hasAdressData">
            <v-layout>
              <v-flex xs12>
                <v-subheader>DANE ADRESOWE</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs5>
                <template v-for="(attribute, index, key) in attributes.address">
                  <template v-if="key < halfAddressAttributesLength">
                    <v-text-field
                      :key="`firstLine${index}`"
                      v-if="attribute && attribute.type === 'text'"
                      :readonly="!editing"
                      v-model="attribute.value"
                      :label="attribute.display_name"
                    ></v-text-field>
                    <v-menu
                      v-else-if="attribute.type === 'date'"
                      v-model="attribute.dateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :key="`firstLine${index}`"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :readonly="!editing"
                    >
                      <template :readonly="!editing" v-slot:activator="{ on }">
                        <v-text-field
                          v-model="attribute.dateFormatted"
                          :label="attribute.display_name"
                          prepend-icon="event"
                          :readonly="!editing"
                          @input="
                            attribute.value = parseDate(attribute.dateFormatted)
                          "
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="attribute.value"
                        @input="attribute.dateMenu = false"
                        color="#2a579a"
                        no-title
                        :readonly="!editing"
                      ></v-date-picker>
                    </v-menu>
                    <v-select
                      v-else
                      :items="attribute.dict.values"
                      :key="`firstLine${index}`"
                      :clearable="editing"
                      no-data-text="Brak wartości słownikowych"
                      v-model="attribute.value"
                      :readonly="!editing"
                      :label="attribute.display_name"
                      :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                    ></v-select>
                  </template>
                </template>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <template
                  v-for="(attribute, index, keyS) in attributes.address"
                >
                  <template v-if="keyS >= halfAddressAttributesLength">
                    <v-text-field
                      :key="`secondLine${index}`"
                      v-if="attribute && attribute.type === 'text'"
                      :readonly="!editing"
                      v-model="attribute.value"
                      :label="attribute.display_name"
                    ></v-text-field>
                    <v-menu
                      v-else-if="attribute && attribute.type === 'date'"
                      v-model="attribute.dateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :key="`secondLine${index}`"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :readonly="!editing"
                    >
                      <template :readonly="!editing" v-slot:activator="{ on }">
                        <v-text-field
                          v-model="attribute.dateFormatted"
                          :label="attribute.display_name"
                          prepend-icon="event"
                          :readonly="!editing"
                          @input="
                            attribute.value = parseDate(attribute.dateFormatted)
                          "
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="attribute.value"
                        @input="attribute.dateMenu = false"
                        color="#2a579a"
                        no-title
                        :readonly="!editing"
                      ></v-date-picker>
                    </v-menu>
                    <v-select
                      v-else-if="attribute && attribute.type === 'select'"
                      :clearable="editing"
                      :items="attribute.dict.values"
                      :key="`secondLine${index}`"
                      no-data-text="Brak wartości słownikowych"
                      v-model="attribute.value"
                      :readonly="!editing"
                      :label="attribute.display_name"
                      :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                    ></v-select>
                  </template>
                </template>
              </v-flex>
            </v-layout>
          </template>
          <template v-if="hasRegistryData">
            <v-layout>
              <v-flex xs12>
                <v-subheader>DANE EWIDENCYJNE</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs5>
                <template
                  v-for="(attribute, index, key) in attributes.registry"
                >
                  <template v-if="key < halfRegistryAttributesLength">
                    <!-- registry_task -->
                    <template v-if="attribute.display_name === 'Kod zadania'">
                      <v-select
                        :key="`firstLine${index}`"
                        v-model="featureInvestments"
                        :items="featureInvestments"
                        label="Powiązane inwestycje"
                        multiple
                        :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                        readonly
                      >
                        <template v-slot:selection="{ item }">
                          <v-chip @click="openInvestmentCard(item)">
                            <span>{{ item }}</span>
                          </v-chip>
                        </template>
                      </v-select>
                    </template>
                    <template v-else>
                      <v-text-field
                        :key="`firstLine${index}`"
                        v-if="attribute && attribute.type === 'text'"
                        :readonly="!editing"
                        v-model="attribute.value"
                        :label="attribute.display_name"
                      ></v-text-field>
                      <v-menu
                        v-else-if="attribute.type === 'date'"
                        v-model="attribute.dateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :key="`firstLine${index}`"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        :readonly="!editing"
                      >
                        <template
                          :readonly="!editing"
                          v-slot:activator="{ on }"
                        >
                          <v-text-field
                            v-model="attribute.dateFormatted"
                            :label="attribute.display_name"
                            prepend-icon="event"
                            :readonly="!editing"
                            @input="
                              attribute.value = parseDate(
                                attribute.dateFormatted
                              )
                            "
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="attribute.value"
                          @input="attribute.dateMenu = false"
                          color="#2a579a"
                          no-title
                          :readonly="!editing"
                        ></v-date-picker>
                      </v-menu>
                      <v-select
                        v-else
                        :clearable="editing"
                        :items="attribute.dict.values"
                        :key="`firstLine${index}`"
                        no-data-text="Brak wartości słownikowych"
                        v-model="attribute.value"
                        :readonly="!editing"
                        :label="attribute.display_name"
                        :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                      ></v-select>
                    </template>
                  </template>
                </template>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <template
                  v-for="(attribute, index, keyS) in attributes.registry"
                >
                  <template v-if="keyS >= halfRegistryAttributesLength">
                    <template v-if="attribute.display_name === 'Kod zadania'">
                      <v-select
                        :key="`secondLine${index}`"
                        :clearable="editing"
                        v-model="featureInvestments"
                        :items="featureInvestments"
                        label="Powiązane inwestycje"
                        multiple
                        :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                        readonly
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index === 0">
                            <span>{{ item }}</span>
                          </v-chip>
                          <span v-if="index === 1" class="grey--text caption"
                            >(+{{ value.length - 1 }} others)</span
                          >
                        </template>
                      </v-select>
                    </template>
                    <template v-else>
                      <v-text-field
                        :key="`secondLine${index}`"
                        v-if="attribute && attribute.type === 'text'"
                        :readonly="!editing"
                        v-model="attribute.value"
                        :label="attribute.display_name"
                      ></v-text-field>
                      <v-menu
                        v-else-if="attribute && attribute.type === 'date'"
                        v-model="attribute.dateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :key="`secondLine${index}`"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        :readonly="!editing"
                      >
                        <template
                          :readonly="!editing"
                          v-slot:activator="{ on }"
                        >
                          <v-text-field
                            v-model="attribute.dateFormatted"
                            :label="attribute.display_name"
                            prepend-icon="event"
                            :readonly="!editing"
                            @input="
                              attribute.value = parseDate(
                                attribute.dateFormatted
                              )
                            "
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="attribute.value"
                          @input="attribute.dateMenu = false"
                          color="#2a579a"
                          no-title
                          :readonly="!editing"
                        ></v-date-picker>
                      </v-menu>
                      <v-select
                        v-if="attribute && attribute.type === 'select'"
                        :clearable="editing"
                        :items="attribute.dict.values"
                        :key="`secondLine${index}`"
                        no-data-text="Brak wartości słownikowych"
                        v-model="attribute.value"
                        :readonly="!editing"
                        :label="attribute.display_name"
                        :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                      ></v-select>
                    </template>
                  </template>
                </template>
              </v-flex>
            </v-layout>
          </template>
          <template v-if="hasModelData">
            <v-layout>
              <v-flex xs12>
                <v-subheader>DANE DO MODELU</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs5>
                <template v-for="(attribute, index, key) in attributes.model">
                  <template v-if="key < halfModelAttributesLength">
                    <v-text-field
                      :key="`firstLine${index}`"
                      v-if="attribute && attribute.type === 'text'"
                      :readonly="!editing"
                      v-model="attribute.value"
                      :label="attribute.display_name"
                    ></v-text-field>
                    <v-menu
                      v-else-if="attribute.type === 'date'"
                      v-model="attribute.dateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :key="`firstLine${index}`"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :readonly="!editing"
                    >
                      <template :readonly="!editing" v-slot:activator="{ on }">
                        <v-text-field
                          v-model="attribute.dateFormatted"
                          :label="attribute.display_name"
                          prepend-icon="event"
                          :readonly="!editing"
                          @input="
                            attribute.value = parseDate(attribute.dateFormatted)
                          "
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="attribute.value"
                        @input="attribute.dateMenu = false"
                        color="#2a579a"
                        no-title
                        :readonly="!editing"
                      ></v-date-picker>
                    </v-menu>
                    <v-select
                      v-else
                      :items="attribute.dict.values"
                      :clearable="editing"
                      :key="`firstLine${index}`"
                      no-data-text="Brak wartości słownikowych"
                      v-model="attribute.value"
                      :readonly="!editing"
                      :label="attribute.display_name"
                      :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                    ></v-select>
                  </template>
                </template>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <template v-for="(attribute, index, keyS) in attributes.model">
                  <template v-if="keyS >= halfModelAttributesLength">
                    <v-text-field
                      :key="`secondLine${index}`"
                      v-if="attribute && attribute.type === 'text'"
                      :readonly="!editing"
                      v-model="attribute.value"
                      :label="attribute.display_name"
                    ></v-text-field>
                    <v-menu
                      v-else-if="attribute && attribute.type === 'date'"
                      v-model="attribute.dateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :key="`secondLine${index}`"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                      :readonly="!editing"
                    >
                      <template :readonly="!editing" v-slot:activator="{ on }">
                        <v-text-field
                          v-model="attribute.dateFormatted"
                          :label="attribute.display_name"
                          prepend-icon="event"
                          :readonly="!editing"
                          @input="
                            attribute.value = parseDate(attribute.dateFormatted)
                          "
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="attribute.value"
                        @input="attribute.dateMenu = false"
                        color="#2a579a"
                        no-title
                        :readonly="!editing"
                      ></v-date-picker>
                    </v-menu>
                    <v-select
                      v-if="attribute && attribute.type === 'select'"
                      :clearable="editing"
                      :items="attribute.dict.values"
                      :key="`secondLine${index}`"
                      no-data-text="Brak wartości słownikowych"
                      v-model="attribute.value"
                      :readonly="!editing"
                      :label="attribute.display_name"
                      :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                    ></v-select>
                  </template>
                </template>
              </v-flex>
            </v-layout>
          </template>
        </template>
        <v-flex v-show="!hasAnyData">
          <v-card-text class="msg--no-data" style="font-weight: bolder"
            >Trwa ładowanie danych</v-card-text
          >
        </v-flex>
      </v-tab-item>
      <v-tab v-if="featureEvents != undefined"
        >ZDARZENIA ({{ featureEvents.events_count }})</v-tab
      >
      <v-tab v-else>ZDARZENIA (0)</v-tab>
      <v-tab-item>
        <template>
          <Events
            v-if="featureData"
            style="margin-top: 15px"
            :featureEvents="featureEvents"
            :objectType="objectType"
            :objectTable="objectTable"
            :module="module"
            :id="objectID"
          />
        </template>
      </v-tab-item>
      <v-tab v-if="objectTable == 'partitions'">WODOMIERZE</v-tab>
      <v-tab-item v-if="objectTable == 'partitions'">
        <template>
          <v-expansion-panel
            class="prw-card__watermeters"
            v-if="watermeters.length > 0"
          >
            <v-expansion-panel-content
              v-for="watermeter in watermeters"
              :key="watermeter.id"
            >
              <template v-slot:header>
                <div>WODOMIERZ: {{ watermeter.properties.id }}</div>
              </template>
              <v-card>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-text-field
                        label="ID"
                        v-model="featureData.id"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer />
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.billing_id"
                        label="Identyfikator w systemie billingowym"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.idwodomierz"
                        label="ID wodomierza"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer />
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.nrkartotekiwodomierz"
                        label="Numer kartoteki wodomierza"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.nrwodomierz"
                        label="Numer wodomierza"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer />
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.status"
                        label="Status"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.dataodczyt"
                        label="Data odczytu"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer />
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.odczyt"
                        label="Odczyt"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.idobiektu"
                        label="ID obiektu"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer />
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.akronimobiekt"
                        label="Akronim obiektu"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.miejscowosc"
                        label="Miejscowość"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer />
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.ulica"
                        label="Ulica"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.nrdomu"
                        label="Numer domu"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer />
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.nrlokalu"
                        label="Numer lokalu"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.wlasnoscprzylacza"
                        label="Własność przyłącza"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer />
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.srednicawodomierz"
                        label="Średnica wodomierza"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.datamontazwodomierz"
                        label="Data montażu wodomierza"
                      ></v-text-field>
                    </v-flex>
                    <v-spacer />
                    <v-flex xs5>
                      <v-text-field
                        v-model="watermeter.properties.datalegalnosciwodomierz"
                        label="Upływ cech legalizacji"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <span
                    class="btn--card"
                    title="Otwórz kartę obiektu"
                    @click="openWatermeter"
                  >
                    <v-icon
                      class="table__btn--blue table__btn--padding"
                      style="padding-left: 25px;"
                      >note</v-icon
                    >
                    <p class="caption caption--identification">KARTA OBIEKTU</p>
                  </span>
                </v-container>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <span v-else>Ładowanie wodomierzy w toku...</span>
        </template>
      </v-tab-item>
      <v-tab>ZAŁĄCZNIKI ({{ attachmentsArr.data.length }})</v-tab>
      <v-tab-item>
        <template>
          <v-layout row>
            <v-flex xs12 v-if="$can('read', module) || $can('edit', module)">
              <div
                v-if="
                  ifAttachments.hasOwnProperty('data') &&
                    attachmentsArr.data.length > 0
                "
              >
                <v-subheader class="font--primary"
                  >Powiązane załączniki</v-subheader
                >
                <li
                  class="list__container--el"
                  v-for="(index, key) in attachmentsArr.data"
                  :key="key"
                >
                  <span>{{ index.id }} - {{ index.filename }}</span>
                  <span>
                    <v-icon
                      @click="downloadAttachment(index.id, index.filename)"
                      small
                      title="Pobierz załącznik"
                      v-if="$can('read', module) || $can('edit', module)"
                      >cloud_download</v-icon
                    >
                    <v-icon
                      @click="deleteAttachment(index.id)"
                      small
                      title="Usuń załącznik"
                      v-if="$can('edit', module)"
                      >delete</v-icon
                    >
                  </span>
                </li>
              </div>
              <div v-else>
                <v-card-text class="msg--no-data" style="font-weight: bolder"
                  >Brak dostępnych załączników</v-card-text
                >
              </div>
              <AddAttachment
                v-show="editing"
                ref="childComponent"
                @attachmentAdded="updateList()"
                @attachmentDeleted="updateList()"
                @confDialogOpened="triggerDialogAttach"
                :id_="objectID"
                :objectType="objectType"
                :objectTable="module"
                :auto="true"
                :module="module"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap v-show="editing">
            <v-subheader class="font--primary"
              >ZAŁĄCZNIKI Z BAZY DANYCH</v-subheader
            >
          </v-layout>
          <v-layout row wrap style="height: 90%" v-show="editing">
            <v-flex xs12>
              <DatabaseAttachments
                :objectIdCard="featureData.id"
                :objectTableCard="module"
                :objectTypeCard="objectType"
                @attachmentAdded="updateList"
              />
            </v-flex>
          </v-layout>
        </template>
      </v-tab-item>
    </v-tabs>
  </Modal>
</template>
<script>
import Modal from "./Modal";
import Events from "./Events";
import AddAttachment from "./AddAttachment";
import DatabaseAttachments from "../viewer/table/attachments/DatabaseAttachments";

export default {
  components: {
    Modal,
    Events,
    AddAttachment,
    DatabaseAttachments
  },
  data: () => ({
    // Właściwości modala
    objectType: "layers",
    objectTable: "",
    module: "",
    // Dane obiektu
    attachmentsArr: {
      data: []
    },
    attributes: {
      default: {},
      address: {},
      model: {},
      registry: {}
    },
    attributesCopy: {},
    featureData: {},
    geometry: undefined,
    watermeters: [],
    // Dane do sterowania komponentami
    editing: false,
    firstLineRange: [],
    secondLineRange: [],
    halfDefaultAttributesLength: undefined,
    isUserLayer: false,
    objectID: undefined,
    featureInvestments: []
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    layer() {
      let layer = undefined;
      layer = this.$store.getters.getLayers.find(
        layer => layer.full_type === this.objectTable
      );
      if (!layer) {
        layer = this.$store.getters.getUserLayers.find(
          layer => layer.name === this.objectTable
        );
      }
      if (!layer) {
        layer = this.$store.getters.getAppLayersMeta.find(
          layer => layer.table === this.objectTable
        );
      }
      return layer;
    },
    cardTitle() {
      let title = "KARTA OBIEKTU";
      if (this.layer && this.featureData) {
        title += ` O ID ${this.objectID} Z WARSTWY ${this.layer.name}`;
      }
      return title;
    },
    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    hasAdressData() {
      return this.hasAttributes(this.attributes.address);
    },
    hasDefaultData() {
      return this.hasAttributes(this.attributes.default);
    },
    hasModelData() {
      return this.hasAttributes(this.attributes.model);
    },
    hasRegistryData() {
      return this.hasAttributes(this.attributes.registry);
    },
    hasAnyData() {
      return Object.keys(this.attributes).some(key =>
        this.hasAttributes(this.attributes[key])
      );
    }
  },
  watch: {
    "attributes.default"(val) {
      if (val) {
        this.halfDefaultAttributesLength = Math.round(
          Object.keys(val).length / 2
        );
      }
    },
    "attributes.address"(val) {
      if (val) {
        this.halfAddressAttributesLength = Math.round(
          Object.keys(val).length / 2
        );
      }
    },
    "attributes.model"(val) {
      if (val) {
        this.halfModelAttributesLength = Math.round(
          Object.keys(val).length / 2
        );
      }
    },
    "attributes.registry"(val) {
      if (val) {
        this.halfRegistryAttributesLength = Math.round(
          Object.keys(val).length / 2
        );
      }
    },
    layer(val) {
      if (val) {
        if (!val.hasOwnProperty("full_type")) {
          if (val.hasOwnProperty("posted_by")) {
            this.isUserLayer = true;
            this.objectType = "user_layers";
            this.module = "canEditUserLayer";
          } else {
            this.objectType = "app_layers";
            this.module = "canAddEvent";
          }
        } else {
          this.module = this.objectTable.split("@")[0];
        }
      }
    }
  },
  methods: {
    cancelEditing() {
      this.editing = false;
      this.attributes = Object.assign({}, this.attributesCopy);
    },
    cardOpened(layer, data, id) {
      this.objectType = "layers";
      if (!layer.startsWith("user_layer_")) {
        if (!layer.startsWith("app_layer_")) {
          this.objectTable = layer;
        } else {
          this.objectTable = layer.split(":")[1];
        }
      } else {
        this.objectTable = layer.slice(11);
      }
      this.objectID = id;
      const attrs = Object.assign({}, data.getProperties());
      if ("geometry" in attrs) {
        //zawsze powinna być chyba że tabela bez geometrii ale takich już nie mamy
        this.geometry = data.getGeometry();
        delete attrs.geometry;
      }
      this.featureData = attrs;
      this.$store
        .dispatch("getFeatureInvestments", {
          object_type: "layers",
          object_layer: layer,
          object_id: id
        })
        .then(r => {
          if (r.status === 200) {
            this.featureInvestments = r.data.data;
          }
        });
      this.show("featureCardModal");
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    closed() {
      this.attributes = {
        default: {},
        address: {},
        model: {},
        registry: {}
      };
      this.attributesCopy = {};
      this.objectType = "";
      this.objectTable = "";
      this.isUserLayer = false;
      this.module = "";
      this.editing = false;
    },
    deleteAttachment(attachmentId) {
      this.$refs.childComponent.deleteAttachment(attachmentId);
    },
    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.childComponent.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    openInvestmentCard(investmentID) {
      if (this.activeModals.includes("investmentCardModal")) {
        this.$modal.hide("investmentCardModal");
      }
      this.$store.dispatch("getSingleInvestment", investmentID).then(r => {
        this.show("investmentCardModal");
        this.$root.$emit("loadTab", 0);
        this.$root.$emit("loadInvestment", r);
      });
    },
    formatDate(date) {
      if (!date) {
        return null;
      } else {
        const [year, month, day] = date.split("-");
        return `${day}.${month}.${year}`;
      }
    },
    getDicts() {
      this.$store
        .dispatch("getDictST", {
          schema: "aquagis",
          table: this.module
        })
        .then(r => {
          if (r.status === 200) {
            if (this.layer && this.featureData) {
              const attributesTypes = ["address", "registry", "model"];
              this.layer.fields.forEach(field => {
                let prefix = field.name.split("_")[0];
                if (!attributesTypes.includes(prefix)) {
                  prefix = "default";
                }
                this.$set(this.attributes[prefix], field.name, {});
                this.$set(
                  this.attributes[prefix][field.name],
                  "value",
                  this.featureData[field.name]
                );
                this.attributes[prefix][field.name].display_name =
                  field.display_name || this.capitalizeFirstLetter(field.name);
                this.attributes[prefix][field.name].dict = r.data.find(
                  dict => dict.description === field.display_name
                );
                if (this.attributes[prefix][field.name].dict) {
                  this.attributes[prefix][field.name].type = "select";
                  this.attributes[prefix][field.name].value = String(
                    this.attributes[prefix][field.name].value
                  );
                } else if (field.data_type === "string") {
                  this.attributes[prefix][field.name].type = "text";
                } else if (field.data_type === "datetime") {
                  this.attributes[prefix][field.name].type = "date";
                  this.$set(
                    this.attributes[prefix][field.name],
                    "dateFormatted",
                    this.attributes[prefix][field.name].value
                      ? this.formatDate(
                          this.attributes[prefix][field.name].value.slice(0, 10)
                        )
                      : null
                  );
                  this.$watch(
                    `attributes.${[prefix]}.${[field.name]}.value`,
                    value => {
                      if (
                        this.attributes &&
                        this.attributes[prefix] &&
                        this.attributes[prefix][field.name] &&
                        this.attributes[prefix][field.name].value
                      ) {
                        this.attributes[prefix][
                          field.name
                        ].dateFormatted = this.formatDate(value.slice(0, 10));
                      }
                    }
                  );
                  this.$set(
                    this.attributes[prefix][field.name],
                    "dateMenu",
                    false
                  );
                }
                // else if(field.type === "time") {
                //   this.attributes[field.name].type = "text";
                // } else if(field.type === "datetime") {
                //   this.attributes[field.name].type = "text";
                // }
                else if (
                  field.data_type === "integer" ||
                  field.data_type === "real"
                ) {
                  this.attributes[prefix][field.name].type = "text"; //TODO: number
                } else {
                  this.attributes[prefix][field.name].type = "text";
                }
              });
            }
          } else {
            return false;
          }
        });
    },
    hasAttributes(object) {
      return Object.keys(object).length > 0;
    },
    openWatermeter() {
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Trwa ładowanie karty wodomierza"
      );
      let watermeter = this.watermeters.find(
        el => el.properties.parent_partition == this.featureData.id
      );
      let payload = {
        layername: "watermeters",
        srid: 2180,
        with_geometry: true
      };
      this.$store.dispatch("getFeatures", payload).then(r => {
        let watermeters = r.features;
        let payloadEvents = {
          object_id: watermeter.id,
          object_type: "watermeters",
          limit: 5,
          events_count: true
        };
        let singleWatermeter = watermeters.filter(el => el.id == watermeter.id);
        this.$root.$emit("loadWatermeterCard", singleWatermeter);
        this.$store.dispatch("getFeatureEvents", payloadEvents).then(() => {
          this.show("watermeterCard");
        });
      });
    },
    saveEditing() {
      if (!this.isUserLayer) {
        let payload = {
          table: this.module,
          body: {
            ids: [this.featureData.id],
            properties: this.preparePayload()
          }
        };
        if (Object.keys(payload.body.properties).length > 0) {
          this.$store.dispatch("editFeature", payload).then(r => {
            if (r.status === 200) {
              for (let property in payload.body.properties) {
                this.featureData[property] = payload.body.properties[property];
              }
              this.$root.$emit(
                "featureEdited",
                JSON.parse(JSON.stringify(this.featureData))
              );
              // this.$root.$emit(`edited_${this.objectTable.slice(0, -1)}`)
            } else {
              this.$root.$emit(
                "showSnackbar",
                "red",
                "Podczas edytowania danych przyłącza wystąpił błąd"
              );
            }
          });
        }
        this.editing = false;
      } else {
        let payload = {
          data: {
            put: [this.preparePayloadUserLayer()],
            delete: [],
            post: []
          },
          table: this.layer.name
        };
        if (Object.keys(payload.put[0].properties.length > 0)) {
          this.$store.dispatch("editUserLayerFeature", payload).then(r => {
            if (r.status === 200) {
              for (let property in payload.data.put[0].properties) {
                this.featureData[property] =
                  payload.data.put[0].properties[property];
              }
              this.$root.$emit(
                "featureEdited",
                JSON.parse(JSON.stringify(this.featureData))
              );
              // this.$root.$emit(`edited_${this.objectTable.slice(0, -1)}`)
            } else {
              this.$root.$emit(
                "showSnackbar",
                "red",
                "Podczas edytowania danych przyłącza wystąpił błąd"
              );
            }
          });
        }
        this.editing = false;
      }
    },
    startEditing() {
      this.editing = true;
      this.attributesCopy = JSON.parse(JSON.stringify(this.attributes));
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("-");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    preparePayload() {
      let payload = {};
      for (let group in this.attributes) {
        for (let attribute in this.attributes[group]) {
          if (
            this.attributes[group][attribute].value !==
            this.attributesCopy[group][attribute].value
          ) {
            payload[attribute] =
              this.attributes[group][attribute].value || null;
          }
        }
      }
      return payload;
    },
    preparePayloadUserLayer() {
      let payload = {
        properties: {}
      };
      for (let group in this.attributes) {
        for (let attribute in this.attributes[group]) {
          payload.properties[attribute] =
            Number(this.attributes[group][attribute].value) ||
            this.attributes[group][attribute].value;
        }
      }
      payload.type = "Feature";
      payload.id = this.objectID;
      payload.properties.id = this.objectID;
      payload.properties.ogc_fid = this.objectID;
      payload.geometry = {
        type:
          this.capitalizeFirstLetter(this.layer.geometry_type) === "Line"
            ? "LineString"
            : this.capitalizeFirstLetter(this.layer.geometry_type),
        coordinates: this.geometry.getCoordinates()
      };
      return payload;
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    updateList() {
      if (this.featureData && this.featureData.id) {
        let payload = {
          object_type: this.objectType,
          layer: this.module,
          oid: this.featureData.id
        };
        this.$store
          .dispatch("getAttachmentsForObject", payload)
          .then(success => {
            if (success) {
              this.attachmentsArr = this.$store.getters.getObjectAttachments;
            }
          });
      }

      if (this.objectTable == "partitions") {
        let payload = {
          layername: "watermeters",
          srid: 2180,
          with_geometry: true
        };
        this.$store.dispatch("getFeatures", payload).then(r => {
          this.watermeters = r.features.filter(
            el => el.properties.parent_partition == this.featureData.id
          );
        });
      }
    }
  },
  mounted() {
    this.$root.$on("featureData", this.cardOpened);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/FeatureCard.vue